// Fomatting Date as YYYY-MM-DD
function yyyymmdd(date) {
  if (!date) {
    return;
  }

  let day;
  let month;
  let year;

  if (typeof date === 'string') {
    day = date.slice(0, 2);
    month = date.slice(3, 5);
    year = date.slice(6);
  }

  if (typeof date === 'object') {
    year = date.getFullYear();
    month = 1 + date.getMonth();
    if (String(month).length === 1) {
      month = '0' + month;
    }
    day = date.getDate();
    if (String(day).length === 1) {
      day = '0' + day;
    }
  }

  return year + '-' + month + '-' + day;
}

// Calculate day diffrence between two dates
export function daysDiff(startDate, endDate) {
  const formattedStartDate = yyyymmdd(startDate);
  const formattedEndDate = yyyymmdd(endDate);

  const diffTime = +new Date(formattedEndDate) - +new Date(formattedStartDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return false;
  }

  return true;
}

// Time converter 12hours clock to 24hours clock
function clock12To24(amPmString): string {
  const date = new Date('1/1/2025 ' + amPmString);
  let time = date.getHours() + ':' + date.getMinutes();
  let [hour, min] = time.split(':');

  if (parseInt(hour) < 10) {
    hour = '0' + hour;
  }

  if (parseInt(min) < 10) {
    min = '0' + min;
  }

  return hour + ':' + min;
}

// Calculate diffrence between two times
export function timesDiff(start, end) {
  start = clock12To24(start);
  end = clock12To24(end);

  start = start.split(':');
  end = end.split(':');
  var startDate = new Date(0, 0, 0, start[0], start[1], 0);
  var endDate = new Date(0, 0, 0, end[0], end[1], 0);
  var diff = endDate.getTime() - startDate.getTime();
  var hours = Math.floor(diff / 1000 / 60 / 60);
  diff -= hours * 1000 * 60 * 60;
  var minutes = Math.floor(diff / 1000 / 60);

  return (
    (hours < 9 ? '0' : '') + hours + ':' + (minutes < 9 ? '0' : '') + minutes
  );
}

// Helper function for a specific date and time combination
export function dateAndTimeConverter(date, time) {
  if (!date || !time) {
    return;
  }

  let year;
  let month;
  let day;

  if (typeof date === 'string') {
    day = date.slice(0, 2);
    month = date.slice(3, 5);
    year = date.slice(6);
  }

  if (typeof date === 'object') {
    year = date.getFullYear();

    month = 1 + date.getMonth();
    if (String(month).length === 1) {
      month = '0' + month;
    }

    day = date.getDate();
    if (String(day).length === 1) {
      day = '0' + day;
    }
  }

  const dateInRequireFormat = year + '-' + month + '-' + day;
  const timeInRequireFormat = clock12To24(time);

  return dateInRequireFormat + ' ' + timeInRequireFormat;
}

// Helper function for check if two dates is a same day
export function sameDay(date, otherDate) {
  if (!date || !otherDate) {
    return false;
  }

  if (date.length === 10) {
    const datePart = date.split('-');
    const dateObject = new Date(+datePart[2], datePart[1] - 1, +datePart[0]);
    date = new Date(dateObject);
  }

  if (otherDate.length === 10) {
    const datePart = otherDate.split('-');
    const dateObject = new Date(+datePart[2], datePart[1] - 1, +datePart[0]);
    otherDate = new Date(dateObject);
  }

  return date.toDateString() === otherDate.toDateString();
}

// Basic validation for auction price
/*
Parameters help
op => opening price
lpa => lowest price to accept
iv => incrimental value
bnp => buy now price
*/
export function auctionPriceCheck(
  op: string,
  lpa: string,
  iv: string,
  bnp: string
): { status: boolean; message: string } {
  if (!op || !lpa || !iv || !bnp) {
    return { status: false, message: 'Please fill all field for price' };
  } else if (parseInt(op) < 1) {
    return { status: false, message: 'Opening price should be greater than 0' };
  } else if (parseInt(lpa) < parseInt(op)) {
    return {
      status: false,
      message:
        'Lowest price to Accept should be greater than or equal to Opening price',
    };
  } else if (parseInt(lpa) > parseInt(bnp)) {
    return {
      status: false,
      message:
        'Lowest price to accept should not be greater than Buy now price',
    };
  } else if (parseInt(iv) < 1) {
    return {
      status: false,
      message: 'Incremental Value should be grater than 0',
    };
  } else if (parseInt(iv) > parseInt(bnp)) {
    return {
      status: false,
      message: 'Incremental value should not be greater than Buy Now Price',
    };
  } else if (parseInt(bnp) < parseInt(op)) {
    return {
      status: false,
      message: 'Buy now price should be greater than or equal to Opening price',
    };
  } else {
    return { status: true, message: '' };
  }
}

export function biddingTimeFormatter(inputDate: string) {
  if (!inputDate) {
    return '--';
  }

  const date = new Date(inputDate);

  let formattedTime = new Intl.DateTimeFormat('en-GB', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
    timeZone: 'Asia/Riyadh', // Saudi Arabia timezone
  }).format(date);

  formattedTime = formattedTime.replace(/([ap]m)/, (match) =>
    match.toUpperCase()
  );

  const formattedDate = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Asia/Riyadh', // Saudi Arabia timezone
  }).format(date);

  const finalFormattedDate = `${formattedTime}, ${formattedDate.replace(
    /\//g,
    '.'
  )}`;

  return finalFormattedDate;
}

export function convertDateFormat(input) {
  // input: "20-11-2025, 09:18:00 AM"

  const [datePart, timePartRaw] = input.split(',');
  const [day, month, year] = datePart.trim().split('-');

  // Convert 12h → 24h time
  let [time, modifier] = timePartRaw.trim().split(' ');
  let [hours, minutes] = time.split(':');

  hours = parseInt(hours, 10);

  if (modifier === 'PM' && hours !== 12) {
    hours += 12;
  } else if (modifier === 'AM' && hours === 12) {
    hours = 0;
  }

  const formattedHours = hours.toString().padStart(2, '0');

  // final format: YYYY-MM-DD HH:MM
  return `${year}-${month}-${day} ${formattedHours}:${minutes}`;
}

export function formatDate(dateString: string) {
  // Split into date and time-with-timezone
  const [datePart, timePart] = dateString.split('T');

  // Extract date components
  const [year, month, day] = datePart.split('-');

  // Extract time BEFORE timezone (+03:00 or -05:00)
  const timeOnly = timePart.split(/[+-]/)[0]; // "17:27:54"
  let [hours, minutes] = timeOnly.split(':');

  let h = Number(hours);

  // Convert to 12-hour format
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;

  // Format final values
  const finalDay = String(day).padStart(2, '0');
  const finalMonth = String(month).padStart(2, '0');
  const finalHours = String(h).padStart(2, '0');
  const finalMinutes = String(minutes).padStart(2, '0');

  return `${finalDay}-${finalMonth}-${year}, ${finalHours}:${finalMinutes} ${ampm}`;
}
